import * as Yup from 'yup';
import { FileTypeEnum } from '@ecdlink/graphql';

export interface ChildRegistrationInformationModel {
  registrationDocumentType: string;
  registrationDocumentTypeId: string;
  registrationDocumentTypeEnumId: FileTypeEnum;
  registrationDocumentBase64String: string;
  registrationFormBase64String: string;
  registrationDocumentFileName: string;
}

export const childRegistrationInformationSchema = Yup.object().shape({
  registrationDocumentType: Yup.string(),
  registrationDocumentTypeId: Yup.string(),
  registrationDocumentBase64String: Yup.string(),
});

export const initialChildRegistrationInformation: ChildRegistrationInformationModel =
  {
    registrationDocumentType: '',
    registrationDocumentTypeId: '',
    registrationDocumentTypeEnumId: FileTypeEnum.ChildClinicCard,
    registrationDocumentBase64String: '',
    registrationDocumentFileName: '',
    registrationFormBase64String: '',
  };
